<template>
    <div class="left side-menu">
        <div class="sidebar-inner slimscrollleft">
            <div id="sidebar-menu" class="pt-2">
<!--                <div id="sidebar-customer-select" class="align-items-center">-->
<!--                    <h4 id="sidebar-customer-select-label" class="text-center">-->
<!--                        <i class="fas fa-user-tie"></i>-->
<!--                        {{ $t("LeftBar.customer") }}-->
<!--                    </h4>-->
<!--                    <transition name="fade" mode="out-in">-->
<!--                        <APILoading v-if="customers === undefined" :text="$t('LeftBar.loadingCustomers')"-->
<!--                                    :font-size="10" :icon-size="15" color="#FFFFFF" key="loading"/>-->
<!--                        <CustomerSelect v-else :customers="customers" key="customer-select"-->
<!--                                        @setCustomerSelected="setCustomerSelected"/>-->
<!--                    </transition>-->
<!--                </div>-->
                <transition name="slide-from-left" mode="out-in">
                    <LeftBarCRM key="crm" v-if="$firstSectionPath === 'crm'" :customers="customers"/>
                    <LeftBarScanning key="scanning" v-else-if="$firstSectionPath === 'scanning'"/>
                    <LeftBarPrinting key="printing" v-else-if="$firstSectionPath === 'printing'"/>
                    <LeftBarStocks key="stocks" v-else-if="$firstSectionPath === 'stocks'"/>
                    <LeftBarDistribution key="distribution" v-else-if="$firstSectionPath === 'distribution'"/>
                    <LeftBarShipping key="shipping" v-else-if="$firstSectionPath === 'shipping'"/>
                    <LeftBarBilling key="billing" v-else-if="$firstSectionPath === 'billing'"/>
                    <LeftBarStatistics key="statistics" v-else-if="$firstSectionPath === 'statistics'"/>
                </transition>
            </div>
            <div class="clearfix"></div>
        </div>
    </div>
</template>

<script>
import LeftBarCRM from "./LeftBarCRM";
import LeftBarScanning from "./LeftBarScanning";
import LeftBarPrinting from "./LeftBarPrinting";
import LeftBarStocks from "./LeftBarStocks";
import LeftBarDistribution from "./LeftBarDistribution";
import LeftBarShipping from "./LeftBarShipping";
import LeftBarBilling from "./LeftBarBilling";
import LeftBarStatistics from "./LeftBarStatistics";

export default {
    name: "LeftBar",
    components: {
        LeftBarStatistics,
        LeftBarBilling,
        LeftBarShipping,
        LeftBarDistribution,
        LeftBarStocks,
        LeftBarPrinting,
        LeftBarScanning,
        LeftBarCRM,
    },
    props: {
        customers: {
            required: true,
        },
    },
    methods: {
        setCustomerSelected(id) {
            this.$emit("setCustomerSelected", id);
        },
    },
};
</script>

<style>
    #sidebar-customer-select {
        height: 75px;
        padding-left: 5%;
        padding-right: 5%;
    }

    #sidebar-customer-select-label {
        color: white;
    }

    .menu-title {
        font-size: 1.6em !important;
        color: white;
    }
</style>